import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import "./alert.script";
const ALERT_ICON_PATHS = {
  info: ["M12 16v-4", "M12 8h.01", "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z"],
  success: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z", "m9 12 2 2 4-4"],
  warning: ["m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3", "M12 9v4", "M12 17h.01"],
  error: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z", "m15 9-6 6", "m9 9 6 6"]
};
export function RuiAlertIcon({
  variant = "info",
  class: className,
  children,
  ...props
}) {
  if (children != null) {
    return /* @__PURE__ */jsx("span", {
      ...props,
      class: cx("rui-alert__icon", className),
      children
    });
  }
  const paths = ALERT_ICON_PATHS[variant];
  const d = Array.isArray(paths) ? paths : [paths];
  return /* @__PURE__ */jsx("span", {
    ...props,
    class: cx("rui-alert__icon", className),
    "aria-hidden": "true",
    children: /* @__PURE__ */jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      children: d.map(path => /* @__PURE__ */jsx("path", {
        d: path
      }))
    })
  });
}
export function RuiAlertTitle({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("p", {
    ...props,
    class: cx("rui-alert__title", className),
    children
  });
}
export function RuiAlertDescription({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-alert__description", className),
    children
  });
}
export function RuiAlert({
  children,
  variant = "info",
  layout = "inline",
  dismissible = false,
  closeLabel = "Dismiss",
  class: className,
  slot,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-alert", {
    slot,
    variant,
    layout,
    dismissible,
    "close-label": closeLabel,
    children: /* @__PURE__ */jsxs("div", {
      ...props,
      class: cx("rui-alert", `rui-alert--${variant}`, `rui-alert--${layout}`, dismissible && "rui-alert--dismissible", className),
      role: "alert",
      children: [children, dismissible ? /* @__PURE__ */jsx("button", {
        type: "button",
        class: "rui-alert__close",
        "data-alert-close": true,
        "aria-label": closeLabel || "Dismiss",
        children: /* @__PURE__ */jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true",
          children: [/* @__PURE__ */jsx("path", {
            d: "M18 6 6 18"
          }), /* @__PURE__ */jsx("path", {
            d: "m6 6 12 12"
          })]
        })
      }) : null]
    })
  });
}